module.exports = __webpack_public_path__ + "img/Bear32.917bad57.jpg";